/**
 * Sidebar list of all dashboard widget types.
 */
Vue.asyncComponent('cms-dashboard-widget-type-list', {
    /**
     * Create the reactive state for this dashboard component.
     */
    data() {
        return {
            q: null,
            loading: false,
            blockTypes: [],
            blockGroupings: [],
            collapsedStates: true,
        };
    },
    props: {
        dataProvider: {
            type: Object,
            required: true,
        },
    },
    computed: {
        /**
         * Return only the groups that still contain visible widget types.
         */
        activeBlockGroups() {
            return this.blockGroupings.filter((blockGrouping) => this.activeBlockTypes.find((blockType) => blockType.groupingId === blockGrouping.id));
        },
        /**
         * Filter widget types by the current search query.
         */
        activeBlockTypes() {
            if (!this.q) {
                return this.blockTypes;
            }

            return this.blockTypes.filter((blockType) => blockType.name?.toLowerCase().includes(this.q.toLowerCase())
                || blockType.nameDefault.toLowerCase().includes(this.q.toLowerCase()));
        },
        /**
         * Return whether the search field currently filters the list.
         */
        searchActive() {
            return this.q !== null && this.q !== '';
        },
    },
    methods: {
        /**
         * Forward the selected widget type to the parent editor.
         */
        setActiveBlockType(newBlock) {
            this.$emit('activeBlockTypeChanged', newBlock);
        },
        /**
         * Create and emit a new widget block from a supported type.
         */
        addNewBlock(type) {
            const newBlock = this.dataProvider.getNewBlockByType(type);
            this.$emit('addNewBlock', newBlock);
            this.setActiveBlockType(newBlock);
        },
        /**
         * Start drag-and-drop by creating a new widget immediately.
         */
        childDragStart(type) {
            this.addNewBlock(type);
        },
        /**
         * Clear the active widget type after dragging ends.
         */
        childDragStop() {
            this.setActiveBlockType(null);
        },
        /**
         * Return all widget types for one grouping.
         */
        getBlockTypes(blockGrouping) {
            return this.activeBlockTypes.filter((blockType) => blockType.groupingId === blockGrouping.id);
        },
    },
    /**
     * Initialize this dashboard component after it is created.
     */
    async created() {
        // Load the available widget types and restore sidebar UI state.
        this.loading = true;
        this.blockGroupings = await this.dataProvider.getBlockGroupings();
        this.blockTypes = await this.dataProvider.getBlockTypes();
        this.loading = false;
        this.collapsedStates = localStorage.getItem('cms-dashboard-widget-group-collapsed-state')
            ? JSON.parse(localStorage.getItem('cms-dashboard-widget-group-collapsed-state'))
            : {};
    },
}, 'cms/dashboard/editor/cms-dashboard-widget-type-list.html');
